import { render, staticRenderFns } from "./request-item.vue?vue&type=template&id=375646ae&scoped=true&"
import script from "./request-item.vue?vue&type=script&lang=js&"
export * from "./request-item.vue?vue&type=script&lang=js&"
import style0 from "./request-item.vue?vue&type=style&index=0&id=375646ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375646ae",
  null
  
)

export default component.exports